import React from "react";
import { Box, Skeleton, Stack } from "./MuiImports";

interface SkeletonLoaderProps {
  count?: number;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ count = 1 }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start", // Changed to flex-start for top alignment
      height: "100vh",
      p: 2,
      my: 10,
    }}
  >
    <Box
      sx={{
        width: "100%",
        maxWidth: "400px",
        p: 2, // Padding inside the card
        borderRadius: 1, // Simulate card border radius
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {Array.from({ length: count }, (_, index) => (
          <React.Fragment key={index}>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              sx={{
                minHeight: "80px",
                padding: "16px",
                backgroundColor: "background.paper",
                borderRadius: "8px",
              }}
            >
              {/* Left Banner Skeleton */}
              <Skeleton
                animation="wave"
                variant="rectangular"
                width={60}
                height={80}
              />

              {/* Right Content Area */}
              <Stack spacing={1} sx={{ flexGrow: 1 }}>
                <Skeleton
                  animation="wave"
                  variant="text"
                  sx={{ fontSize: "1.25rem" }}
                  width="70%"
                />
                <Skeleton
                  animation="wave"
                  variant="text"
                  sx={{ fontSize: "0.9rem" }}
                  width="40%"
                />
                <Skeleton
                  animation="wave"
                  variant="text"
                  sx={{ fontSize: "0.8rem" }}
                />
                <Skeleton
                  animation="wave"
                  variant="text"
                  sx={{ fontSize: "0.8rem" }}
                />
              </Stack>

              {/* Arrow Skeleton on the far right */}
              <Skeleton
                animation="wave"
                variant="circular"
                width={24}
                height={24}
                sx={{ alignSelf: "center", ml: "auto" }}
              />
            </Stack>
            {index < count - 1 && (
              <Box
                sx={{
                  height: "25px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: "1px",
                    backgroundColor: "transparent",
                  }}
                />
              </Box>
            )}
          </React.Fragment>
        ))}
      </Box>
    </Box>
  </Box>
);

export default SkeletonLoader;
